import React from 'react';
import { X, Shield } from 'lucide-react';

interface TradingStatusIndicatorProps {
  isMarketOpen: boolean;
  isHedgeCopyModeActive: boolean;
}

export const TradingStatusIndicator: React.FC<TradingStatusIndicatorProps> = ({
  isMarketOpen,
  isHedgeCopyModeActive,
}) => {
  return (
    <div className="trading-status">
      {!isMarketOpen && (
        <div className="trading-market-closed">
          <X size={8} />
          <span>CLOSED</span>
        </div>
      )}

      {isHedgeCopyModeActive && (
        <div className="trading-hedge-badge">
          <Shield size={8} />
          <span>HEDGE</span>
        </div>
      )}
    </div>
  );
};
